<template>
	<div>
		<div class="ma-4 text-center" v-if="true">
			Due to unavoidable circumstances we are disabling all offline
			transactions with immediate effect
		</div>
		<div v-else>
			<contact-support />
			<div class="my-4 mx-3">
				<gmv-target-banner
					v-if="tsmTargetGmvData.length"
					:retailerId="retailerId"
					:tsmGmv="tsmGmvWeekly"
					:tsmTargetGmvData="tsmTargetGmvData"
					:tsmTargetGmvDataStartDate="tsmTargetGmvDataStartDate"
					:tsmTargetGmvDataEndDate="tsmTargetGmvDataEndDate"
				/>
			</div>
			<v-layout @click="modal = true">
				<v-dialog
					ref="dialog"
					v-model="modal"
					:return-value.sync="date"
					persistent
					width="290px"
				>
					<template v-slot:activator="{ on, attrs }">
						<v-flex xs10 md6 lg3 class="px-4">
							<v-text-field
								v-model="date"
								label="Select Date"
								v-bind="attrs"
								v-on="on"
								prepend-icon="today"
							></v-text-field>
						</v-flex>
					</template>
					<v-date-picker v-model="date" scrollable>
						<v-spacer></v-spacer>
						<v-btn text color="primary" @click="modal = false">
							Cancel
						</v-btn>
						<v-btn
							text
							color="primary"
							@click="$refs.dialog.save(date)"
						>
							OK
						</v-btn>
					</v-date-picker>
				</v-dialog>
			</v-layout>
			<v-layout class="mb-1 px-3 subheading">
				<v-flex>
					<div>
						<strong> {{ currentSelectedMonth }} Earnings : </strong>
						<span class="green--text px-2 subtitle-1">
							₹ {{ amount }}
						</span>
					</div>
				</v-flex>
			</v-layout>
			<v-tabs
				color="#233b5d"
				v-model="selectedTab"
				fixed-tabs
				class="mb-4 mt-2 tabs"
			>
				<v-tabs-slider color="white"></v-tabs-slider>

				<v-tab
					v-for="(tab, index) in tabs"
					:key="index"
					class="white--text"
					:href="'#' + tab.type"
					@click="() => handleTabChage(tab)"
				>
					{{ tab.name }}
				</v-tab>
			</v-tabs>
			<v-tabs-items v-model="selectedTab" touchless>
				<v-tab-item :value="tabs[0].type">
					<leaderboard
						:leaderboard="leaderboard"
						:prizes="prizes"
						:retailerId="retailerId"
						:aggregatedGmv="aggregatedGmv"
						:aggregatedGmvFantasyRummy="aggregatedGmvFantasyRummy"
					/>
				</v-tab-item>
				<v-tab-item :value="tabs[1].type">
					<sales :date="date" :retailerId="retailerId" />
				</v-tab-item>
				<v-tab-item :value="tabs[2].type">
					<associates :date="date" :retailerId="retailerId" />
				</v-tab-item>
			</v-tabs-items>
			<v-dialog
				max-width="600px"
				fullscreen
				hide-overlay
				v-model="showDialog"
			>
				<tsm-target
					@CLOSE_MODAL="showDialog = false"
					:gmvPerDay="gmvPerDay"
					v-if="showDialog"
				/>
			</v-dialog>
		</div>
	</div>
</template>

<script>
import {
	FETCH_TSM_LEADERBOARD,
	FETCH_TSM_EARNING,
	FETCH_TSM_GMV,
	FETCH_TSM_TARGETS
} from "@/store/action-types";
import TSMLeaderboard from "./tsm-leaderboard";
import TSMAssociates from "./tsm-associates";
import TSMSales from "./tsm-sales";
import GMVTargetBanner from "./gmv-target-banner";
import TSMTarget from "./tsm-target.vue";
import ContactSupport from "../contact-support.vue";
import { mapState } from "vuex";
import { MONTHS, TSM_QUARTERLY_TARGETS } from "../constants";
import EventsManager from "@/event-manager";
import { dd_mm_yyToyy_mm_dd } from "../../utils";

export default {
	props: ["appType"],
	data() {
		return {
			modal: false,
			selectedMonth: new Date().getMonth() + 1,
			date: new Date().toISOString().substr(0, 10),
			leaderboard: [],
			prizes: [],
			amount: 0,
			tabs: [
				{ name: "Leaderboard", type: "leaderboard" },
				{ name: "Sales", type: "sales" },
				{ name: "My Associates", type: "associates" }
			],
			selectedTab: null,
			tsmGmv: 0,
			tsmGmvWeekly: 0,
			tsmTargetGmvData: [],
			tsmTargetGmvDataStartDate: null,
			tsmTargetGmvDataEndDate: null,
			showDialog: false,
			TSM_QUARTERLY_TARGETS: TSM_QUARTERLY_TARGETS,
			targetRange: {},
			aggregatedGmv: 0,
			aggregatedGmvFantasyRummy: []
		};
	},
	computed: {
		...mapState({
			retailerId: state => state.auth.USERID,
			userData: state => state.user.userData
		}),
		currentSelectedMonth() {
			return MONTHS[this.selectedMonth - 1];
		},
		gmvPerDay() {
			const date1 = new Date("2021-12-31T18:30:00.000Z");
			const date2 = new Date();
			const timeDifference = date2.getTime() - date1.getTime();
			const dayDiff = Math.ceil(timeDifference / (1000 * 60 * 60 * 24));
			return Math.round(this.tsmGmv / dayDiff);
		},
		lowerTargetRange() {
			return this.gmvPerDay > 160000 ? this.targetRange.lower : 0;
		},
		upperTargetRange() {
			return this.gmvPerDay > 500000
				? null
				: this.gmvPerDay < 160000
				? this.targetRange.lower
				: this.targetRange.upper;
		},
		progress() {
			return Math.round(
				((this.gmvPerDay - this.lowerTargetRange) /
					(this.upperTargetRange - this.lowerTargetRange)) *
					100
			);
		},
		showProgressBar() {
			return this.gmvPerDay < 500000;
		}
	},
	components: {
		leaderboard: TSMLeaderboard,
		associates: TSMAssociates,
		sales: TSMSales,
		"gmv-target-banner": GMVTargetBanner,
		"tsm-target": TSMTarget,
		"contact-support": ContactSupport
	},
	mounted() {
		this.fetchTSMTargetGmvData();
		this.fetchTSMLeaderboard();
		this.fetchTSMEarning();
		this.fetchTSMGmv();
	},
	methods: {
		fetchTSMLeaderboard() {
			const { date, month, year } = this.getDateInfo(this.date);
			this.$store
				.dispatch(FETCH_TSM_LEADERBOARD.dispatch, { date, month, year })
				.then(resp => {
					const {
						leaderboard,
						prizes,
						aggregatedGmv,
						aggregatedGmvFantasyOffline,
						aggregatedGmvFantasyTotal,
						aggregatedGmvRummyOffline,
						aggregatedGmvRummyTotal,
						aggregatedGmvLudoTotal
					} = resp;
					this.leaderboard = leaderboard.filter(
						entry => !!entry.name
					);
					this.prizes = prizes;
					this.aggregatedGmv = aggregatedGmv;
					this.aggregatedGmvFantasyRummy = [
						{
							aggregatedGmvFantasyOffline,
							aggregatedGmvFantasyTotal,
							aggregatedGmvRummyOffline,
							aggregatedGmvRummyTotal,
							aggregatedGmvLudoTotal
						}
					];
				})
				.catch(err => console.log(err));
		},
		fetchTSMEarning() {
			const { month, year } = this.getDateInfo(this.date);
			this.$store
				.dispatch(FETCH_TSM_EARNING.dispatch, { month, year })
				.then(resp => {
					const { amount = 0 } = resp;
					this.amount = amount;
				})
				.catch(err => console.log(err));
		},
		fetchTSMTargetGmvData() {
			this.$store
				.dispatch(FETCH_TSM_TARGETS.dispatch, {
					appType: this.appType
				})
				.then(resp => {
					const { targets, startDate, endDate } = resp;
					this.tsmTargetGmvData = targets;
					this.tsmTargetGmvDataStartDate = startDate;
					this.tsmTargetGmvDataEndDate = endDate;
					if (
						this.tsmTargetGmvData &&
						this.tsmTargetGmvData.length > 0 &&
						this.tsmTargetGmvDataStartDate &&
						this.tsmTargetGmvDataEndDate
					)
						this.fetchTSMGmvWeekly();
				})
				.catch(err => console.log(err));
		},
		getDateInfo(fullDate) {
			const [year, month, date] = fullDate
				.split("-")
				.map(str => Number(str));

			return {
				date,
				month,
				year
			};
		},
		handleTabChage(tab) {
			EventsManager.sendEvent({
				name: "TSM_TAB_CHANGE",
				properties: {
					tab: tab.type,
					userId: this.retailerId,
					dateSelected: this.date
				}
			});
		},
		fetchTSMGmv() {
			this.$store
				.dispatch(FETCH_TSM_GMV.dispatch, {
					startDate: "2022-01-01",
					endDate: "2022-03-31"
				})
				.then(resp => {
					const {
						gmvFantasyTotal = 0,
						gmvRummyTotal = 0,
						gmvLudoTotal = 0
					} = resp;
					this.tsmGmv =
						gmvFantasyTotal + gmvRummyTotal + gmvLudoTotal || 0;
				})
				.catch(err => console.log(err));
		},
		fetchTSMGmvWeekly() {
			this.$store
				.dispatch(FETCH_TSM_GMV.dispatch, {
					startDate: `${dd_mm_yyToyy_mm_dd(
						this.tsmTargetGmvDataStartDate
					)}`,
					endDate: `${dd_mm_yyToyy_mm_dd(
						this.tsmTargetGmvDataEndDate
					)}`
				})
				.then(resp => {
					const { gmvFantasyTotal = 0 } = resp;
					this.tsmGmvWeekly = gmvFantasyTotal || 0;
					this.setTargetRange();
				})
				.catch(err => console.log(err));
		},
		showTargetDialog() {
			EventsManager.sendEvent({
				name: "TSM_QUARTER_TARGET_BANNER_CLICKED",
				properties: {
					userId: this.retailerId
				}
			});
			this.showDialog = true;
		},
		setTargetRange() {
			let selectedIndex = 0;
			this.TSM_QUARTERLY_TARGETS.every((element, index) => {
				if (
					this.gmvPerDay >= element.lower &&
					this.gmvPerDay <= element.upper
				) {
					selectedIndex = index;
					return false;
				}
				return true;
			});
			this.targetRange = this.TSM_QUARTERLY_TARGETS[selectedIndex];
		}
	},
	watch: {
		date(newVal) {
			if (newVal) {
				this.fetchTSMLeaderboard();
				this.fetchTSMEarning();
			}
		}
	}
};
</script>
<style scoped lang="scss">
.bannerContainer {
	display: flex;
	flex-wrap: nowrap;
	overflow-y: scroll;
	align-items: center;
}
.targetBannerImage {
	height: 120px;
	width: 100%;
	margin: 5% 0;
}
.gmvCardContainer {
	background: url("https://cdn.jeet11.com/images/appAssets/renew-membership-card-bg-blue.png");
	background-size: 100%;
	position: relative;
	color: white;
	border-radius: 10px;
	& > .strip {
		position: absolute;
		background: #fafafa;
		color: #014189;
		padding: 0 24px;
		transform: rotate(-45deg);
		font-size: 10px;
		left: -26px;
		top: 20px;
		z-index: 0;
		text-transform: uppercase;
	}
}
.totalGmvContainer {
	position: absolute;
	top: -14px;
	background: white;
	left: 0;
	right: 0;
	margin: auto;
	width: max-content;
	padding: 3px 30px;
	border-radius: 30px;
	box-shadow: 0px 1px 4px rgba(9, 52, 104, 0.65);
	border: 1px solid #014189;
	font-weight: 600;
	font-size: 12px;
	color: #014189;
	letter-spacing: 0.005em;
}
.gmvCardBottomStrip {
	background: linear-gradient(90.04deg, #014189 0.03%, #267fbf 95.88%);
	border-radius: 0px 0px 7px 7px;
	text-align: center;
	/* display: grid;
	grid-template-columns: 60% 40%; */
	font-size: 12px;
}
.divider {
	width: 24px;
	height: 1px;
	background: white;
	margin: 2px;
}
.dailyGmv {
	font-size: 22px;
}
.targetRangeWrapper {
	display: flex;
	justify-content: space-between;
	padding-left: 16px;
	padding-right: 16px;
	align-items: center;
	.smallText {
		font-size: 10px;
	}
	.value {
		min-width: 50px;
	}
}
.progressBarWrapper {
	padding: 3px 16px;
	display: flex;
}
.progressBar {
	height: 4px;
	border-radius: 4px;
	position: relative;
}
.nonSelectedProgressBar {
	background: white;
	margin-left: -2%;
}
.selectedProgressBar {
	background: linear-gradient(269.96deg, #ff9714 0.03%, #f6ede2 99.98%);
	z-index: 1;
}
</style>
